import { SIDE_BAR_VISIBLITY_CLASS } from '../classnames/third-party-buttons';

export default class ThirdPartyLinksHandler {
  hideForSideBar = () => {
    document.body.classList.add(SIDE_BAR_VISIBLITY_CLASS);
  };

  showForSideBar = () => {
    document.body.classList.remove(SIDE_BAR_VISIBLITY_CLASS);
  };
}
